import BottomBoard from "components/Common/Board/BottomBoard";
import Button from "components/foundation/Button";
import Input from "components/foundation/Input/Input";
import Modal from "components/foundation/Modal/Modal";
import useVerifyPasswordMutation from "features/my-page/mutations/useVerifyPasswordMutation";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";

interface FormData {
  password: string;
}

interface PasswordVerificationMobileCardProps {
  onSuccess: () => void;
}

const PasswordVerificationMobileCard = ({
  onSuccess,
}: PasswordVerificationMobileCardProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext<FormData>();
  const [isInvalidModalOpen, setIsInvalidModalOpen] = useState(false);
  const { mutate } = useVerifyPasswordMutation();

  const passwordValidationSubmit = (data: FormData) => {
    mutate(data, {
      onSuccess: () => {
        onSuccess();
      },
      onError: () => {
        setIsInvalidModalOpen(true);
      },
    });
  };

  return (
    <>
      <Modal.Root
        open={isInvalidModalOpen}
        onOpenChange={setIsInvalidModalOpen}
      >
        <Modal.Body
          title="비밀번호가 일치하지 않습니다."
          onConfirm={() => {
            setIsInvalidModalOpen(false);
          }}
        ></Modal.Body>
      </Modal.Root>
      <form onSubmit={handleSubmit(passwordValidationSubmit)}>
        <PasswordVerificationMobileCardLayout>
          <div>
            <h1>비밀번호를 다시 한 번 입력해 주세요.</h1>
            <h2>개인정보 보호를 위해 비밀번호를 다시 입력해야 합니다.</h2>
          </div>
        </PasswordVerificationMobileCardLayout>
        <PasswordBottomBoard>
          <Input
            type="password"
            placeholder="비밀번호를 입력해주세요."
            {...register("password", {
              required: "8자이상 20자 이하로 입력이 필요합니다.",
              minLength: {
                value: 8,
                message: "8자이상 20자 이하로 입력이 필요합니다.",
              },
            })}
            maxLength={20}
            errorMessage={errors.password?.message}
          />
          <Button
            size="mobile"
            type="submit"
            style={{
              padding: "1.6rem 3rem",
            }}
          >
            확인
          </Button>
        </PasswordBottomBoard>
      </form>
    </>
  );
};

export default PasswordVerificationMobileCard;

const PasswordVerificationMobileCardLayout = styled.div`
  width: 19.6rem;
  margin: 0 auto;
  word-break: keep-all;
  h1 {
    margin: 9rem 0rem 2rem 0rem;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }

  h2 {
    ${({ theme }) => theme.typography.body3.regular};
    color: ${({ theme }) => theme.color.text.secondary};
    text-align: center;
  }
`;

const PasswordBottomBoard = styled(BottomBoard)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  height: 24rem;

  & > :first-child {
    flex: 0;
  }
`;
